<template>
  <v-container fluid fill-height>
    <v-row
      no-gutters
      justify="center"
      align-content="center"
      class="fill-height"
    >
      <v-avatar v-if="user" color="primary" :size="size">
        <span class="white--text text-h5">{{ initials }}</span>
      </v-avatar>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "AvatarCustomer",
  computed: {
    ...mapGetters(["user"]),
    initials() {
      if (this.user) {
        return (
          this.user.firstName.slice(0, 1).toUpperCase() +
          this.user.lastName.slice(0, 1).toUpperCase()
        );
      } else {
        return "";
      }
    },
    size() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 50;
        default:
          return 70;
      }
    },
  },
};
</script>
